export default "__VITE_ASSET__DMZKKoB3__"